import React from 'react';
import {useMutation, useQuery} from '@apollo/client';
import Query from '../../components/Query';
import Avatar from '../../components/Avatar';
import Back from '../../components/Back';
import {MUTATION_FRIEND_SAVE, MUTATION_FRIEND_DELETE, QUERY_FRIEND_LIST} from './graphql';
import {QUERY_USER} from '../Client/graphql';
import {updateDelete} from '../../utils/mutation';

const FriendList = () => {
  const query = useQuery(QUERY_FRIEND_LIST);
  const {user} = useQuery(QUERY_USER).data;

  const [save] = useMutation(MUTATION_FRIEND_SAVE);
  const [del] = useMutation(MUTATION_FRIEND_DELETE, {
    update: (cache, response) => updateDelete(cache, response, {query: QUERY_FRIEND_LIST}),
  });

  return (
    <div className="FriendList my-3">
      <div className="row gx-lg-3 gy-3 align-items-center mb-4">
        <div className="col-auto">
          <Back />
        </div>
        <div className="col-auto fw-bold font-4">Заявки в друзья</div>
      </div>
      {Query(query) || (
        <div className="row gx-lg-4 gy-4">
          {query.data.friendList.map(item => {
            const client = item.client1.user.id === user.id ? item.client2 : item.client1;

            return (
              <div key={item.id} className="col-3">
                <div className="border rounded bg-white">
                  <div className="row align-items-center gx-2 p-2">
                    <div className="col-auto">
                      <Avatar user={client.user} size={50} />
                    </div>
                    <div className="col">
                      <div>{client.user.fullname}</div>
                      <div className="text-muted font-2">{client.friendsCount} друзья</div>
                    </div>
                  </div>
                  {item.isAccepted ? (
                    <button
                      onClick={() => del({variables: {input: {id: item.id}}})}
                      className="d-block w-100 btn btn-sm btn-primary"
                    >
                      Удалить дружбу
                    </button>
                  ) : item.client1.user.id === user.id ? (
                    <button
                      onClick={() => del({variables: {input: {id: item.id}}})}
                      className="d-block w-100 btn btn-sm btn-info"
                    >
                      Отменить запрос
                    </button>
                  ) : (
                    <div className="row g-0">
                      <div className="col">
                        <button
                          onClick={() => del({variables: {input: {id: item.id}}})}
                          className="d-block w-100 btn btn-sm btn-info"
                        >
                          Отклонить
                        </button>
                      </div>
                      <div className="col">
                        <button
                          onClick={() => save({variables: {input: {friend: item.client1.id}}})}
                          className="d-block w-100 btn btn-sm btn-success"
                        >
                          Принять
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FriendList;
